module.exports = __webpack_public_path__ + "img/taxi-new.6570275c.png";